const SpinLoad = () => {
  return(
    <div class="container-spinner">
      <div class="spinner"></div>
    </div>
  )
}

export default SpinLoad